import { IUserActionResult } from '../types/IUserActionResult';
import { Request } from './Request';

export interface IImportExternalSiteUsersParams {
  emailAddresses: string[];
  siteRole: string; //SiteRoles
  authSetting: string;
}

export class ImportExternalSiteUsersRequest extends Request<IImportExternalSiteUsersParams, IUserActionResult> {
  constructor(params: IImportExternalSiteUsersParams) {
    super('importExternalUsers', params);
  }
}
